import React, { useEffect, useState } from "react";
import { useCashbookStore } from "../../../config/stores";
import { Alert, Card, Space } from "antd";
import CashbookContext from "./CashbookContext";
import CashbookTable from "./CashbookTable";
import { find, isEmpty } from "lodash";
import AppButton from "../../../components/common/AppButton";
import { AiOutlineFileExcel, AiOutlineFilePdf, AiOutlineReload } from "react-icons/ai";
import generateCashbookPdf from "../../../config/services/cashbookPdf";

const ProjectCashbook = () => {
  const cashbookStore = useCashbookStore();
  const [cashbook, setCashbook] = useState([]);

  useEffect(() => {
    if (!isEmpty(cashbookStore.projectCashbookContext)) {
      const cashbookData = find(cashbookStore.projectCashbook, (records) => {
        return (
          records?.startDate ===
            cashbookStore.projectCashbookContext?.startDate &&
          records?.endDate === cashbookStore.projectCashbookContext?.endDate &&
          records?.projectId === cashbookStore.projectCashbookContext?.projectId
        );
      });
      setCashbook(cashbookData?.data);
    }
  }, [cashbookStore.projectCashbook, cashbookStore.projectCashbookContext]);

  const reloadCashbook = () => {
    if (!isEmpty(cashbookStore.projectCashbookContext)) {
      cashbookStore.getProjectCashbook(cashbookStore.projectCashbookContext);
    }
  };

  const downloadCashbook = () => {
    if (!isEmpty(cashbookStore.projectCashbookContext)) {
      cashbookStore.downloadCashbook(cashbookStore.projectCashbookContext);
    }
  };

  const downloadCashbookPdf = () => {
    if (!isEmpty(cashbookStore.projectCashbookContext)) {
      const project = find(
        cashbookStore.metadata?.projects,
        (item) => item.id === cashbookStore.projectCashbookContext?.projectId
      );
      generateCashbookPdf(
        cashbook?.cashbook,
        cashbookStore.projectCashbookContext.startDate,
        cashbookStore.projectCashbookContext.endDate,
        { projectName: project?.name }
      );
    }
  };

  return (
    <div>
      <Card
        bordered={false}
        title={<CashbookContext showProjects />}
        extra={
          <>
            {!isEmpty(cashbookStore.projectCashbookContext) && (
              <Space>
                <AppButton
                  text="RELOAD"
                  loadingText="RELOADING..."
                  loading={cashbookStore.gettingProjectCashbook}
                  iconBefore={<AiOutlineReload />}
                  onClick={reloadCashbook}
                />
                <AppButton
                  text="DOWNLOAD"
                  danger
                  type="dashed"
                  loadingText="DOWNLOADING..."
                  iconBefore={<AiOutlineFileExcel />}
                  loading={cashbookStore.downloadingCashbook}
                  onClick={downloadCashbook}
                />
                <AppButton
                  text="DOWNLOAD PDF"
                  type="primary"
                  loadingText="GENERATING..."
                  iconBefore={<AiOutlineFilePdf />}
                  onClick={downloadCashbookPdf}
                  disabled={isEmpty(cashbook?.cashbook)}
                />
              </Space>
            )}
          </>
        }
      >
        {isEmpty(cashbookStore.projectCashbookContext) ? (
          <Alert
            type="info"
            showIcon
            message="PLEASE SELECT A PROJECT START DATE AND END DATE TO VIEW THE CASHBOOK"
          />
        ) : (
          <CashbookTable cashbookData={cashbook} />
        )}
      </Card>
    </div>
  );
};

export default ProjectCashbook;
